import React from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";

export default function FaqList({ faqList }) {
  return faqList.map((faq) => (
    <Disclosure as="div" key={faq.question} className="faqs-item mb-5">
      {({ open }) => (
        <>
          <dt className="bg-[#F1F4F6] py-[18px] px-5 rounded-[18px]">
            <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
              <span className="text-lg font-bold leading-[160%] text-customGray">
                {faq.question}
              </span>
              <span className="ml-6 flex h-7 items-center">
                {open ? (
                  <ChevronUpIcon className="h-6 w-6" aria-hidden="true" />
                ) : (
                  <ChevronDownIcon className="h-6 w-6" aria-hidden="true" />
                )}
              </span>
            </Disclosure.Button>
          </dt>
          <Transition
            show={open}
            className="overflow-hidden"
            enter="transition transition-[max-height] duration-500 ease-in"
            enterFrom="transform max-h-0"
            enterTo="transform max-h-screen"
            leave="transition transition-[max-height] duration-500 ease-out"
            leaveFrom="transform max-h-screen"
            leaveTo="transform max-h-0"
          >
            <Disclosure.Panel as="dd" className="px-5 mt-5">
              <p className="text-base leading-[160%] font-normal text-customGray">
                {faq.answer}
              </p>
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  ));
}
